import type { MockTestQuestion } from '../../api/mockTest.types';

/// Logic thuần của màn "Bài test" — bản mobile giống hệt ở
/// apps/mobile/src/screens/hoc/mocktest/mockTestLogic.ts, sửa một chỗ thì sửa cả hai.

export const PART_META = [
  { jp: '文字・語彙', vi: 'Từ vựng', short: '語彙' },
  { jp: '文法・読解', vi: 'Ngữ pháp · Đọc hiểu', short: '文法' },
  { jp: '聴解', vi: 'Nghe hiểu', short: '聴解' },
] as const;

/** Lượt đang làm — chỉ ở trên máy, server không biết gì cho tới khi nộp. */
export interface ExamSession {
  /** order câu → lựa chọn 1-based. */
  answers: Record<number, number>;
  /** Giây đã dùng ở từng phần — đồng hồ chỉ chạy khi đang ở trong phần đó. */
  used: [number, number, number];
  /** Phần đã khoá: bấm "Hoàn thành phần này" hoặc hết giờ. */
  locked: [boolean, boolean, boolean];
}

export const newSession = (): ExamSession => ({ answers: {}, used: [0, 0, 0], locked: [false, false, false] });

export function partQuestions(questions: MockTestQuestion[], part: number): MockTestQuestion[] {
  return questions.filter((q) => q.part === part);
}

export function answeredIn(session: ExamSession, questions: MockTestQuestion[]): number {
  return questions.filter((q) => session.answers[q.order] != null).length;
}

export type PartStatus = { label: string; tone: 'done' | 'doing' | 'todo' };

export function partStatus(session: ExamSession, questions: MockTestQuestion[], partIndex: number): PartStatus {
  const answered = answeredIn(session, questions);
  if (session.locked[partIndex] || answered === questions.length) return { label: 'Xong', tone: 'done' };
  if (answered > 0) return { label: `Đang làm ${answered}/${questions.length}`, tone: 'doing' };
  return { label: 'Chưa làm', tone: 'todo' };
}

const pad = (n: number) => String(n).padStart(2, '0');

/** "09:58" */
export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
}

/** Tách prompt theo <u>…</u>: phần lẻ (index 1, 3, …) là chữ gạch chân. */
export function splitUnderline(prompt: string): string[] {
  return prompt.split(/<u>|<\/u>/);
}

export const BLANK = '（　　）';

/** Lựa chọn ngắn (≤ 6 ký tự) hoặc chỉ hiện số → xếp 2 cột. */
export function optionsInGrid(q: Pick<MockTestQuestion, 'options' | 'optionsHidden'>): boolean {
  return q.optionsHidden || q.options.every((o) => o.length <= 6);
}

export function verdict(totalScore: number, passed: boolean): string {
  if (passed) return 'Đạt mức đỗ (≥ 80/180, không phần nào dưới điểm liệt).';
  if (totalScore >= 80) return 'Tổng điểm đủ nhưng có phần dưới điểm liệt — ôn thêm phần đó rồi thử lại.';
  return 'Chưa đạt 80/180 — xem lại đáp án rồi làm lại, không bị trừ gì cả.';
}
